import { Component } from "react";
import { SupportApiManager } from "../supportApiManager";
import { Button, CloseButton, Container, Dropdown, Form, InputGroup, ListGroup, ListGroupItem, Modal, OverlayTrigger, Stack, Tooltip } from "react-bootstrap";

export class AdminList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            createUserModal: false,
            createUserFirstName: '',
            createUserLastName: '',
            createUserEmail: '',
            createUserDomain: undefined,
        }

        this.apiManager = new SupportApiManager()
    }

    async componentDidMount() {
        await this.getUsersForDistrict(this.props.districtCode)
    }

    async componentDidUpdate(prevProps) {
        if (this.props.districtCode !== prevProps.districtCode || this.props.version !== prevProps.version) {
            await this.getUsersForDistrict(this.props.districtCode)
            this.setState({schools: undefined})
        }
    }

    async getUsersForDistrict(districtCode) {
        const users = await this.apiManager.getUsers(districtCode)
        this.setState({focusedDistrictAdmins: users})
    }

    closeCreateAdminModal() {
        this.setState({
            createUserModal: false,
            createUserFirstName: '',
            createUserLastName: '',
            createUserEmail: '',
            createUserDomain: undefined,
        })
    }

    async openCreateAdminModal() {
        let schools = this.state.schools
        if (schools === undefined) {
            schools = await this.apiManager.getSchoolsForDistrict(this.props.districtCode)
        }
        this.setState({
            schools,
            createUserModal: true,
        })
    }

    updateModalSelector(value) {
        this.setState({
            createUserDomain: value,
        })
    }

    updateModalTypingValues = field => (e) => {
        this.setState({
            [field]: e.target.value,
        })
    }

    async createNewUser() {
        const userCreated = await this.apiManager.createAdminUser(
            this.state.createUserFirstName,
            this.state.createUserLastName,
            this.state.createUserEmail,
            this.state.createUserDomain,
            this.props.districtCode
        )
        if (userCreated) {
            this.closeCreateAdminModal()
            alert(`New user ${this.state.createUserEmail} created. Email has been sent`)
            await this.getUsersForDistrict(this.props.districtCode)
        }
    }

    updateDeleteAdminValue(val) {
        this.setState({adminDeleteModal: val})
    }

    async removeAdminFromDistrict(val) {
        const res = await this.apiManager.deleteAdminUser(val, this.props.districtCode)
        if (res) {
            this.updateDeleteAdminValue(undefined)
            this.getUsersForDistrict(this.props.districtCode)
        }
    }

    render() {
        return (
            <Container className="mt-3">
                <h5>Admins</h5>
                <ListGroup>
                    {this.state.focusedDistrictAdmins && this.state.focusedDistrictAdmins.map((item, idx) => 
                        <ListGroupItem key={idx}>
                            <Stack direction="horizontal" className="justify-content-between">
                                <div>
                                    <span>{item.firstName} {item.lastName} </span>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip className="no-wrap-tooltip">{item.email}</Tooltip>}
                                    >
                                        <i class="bi bi-info-circle"></i>
                                    </OverlayTrigger>
                                </div>
                                <div>
                                    <span className="me-2">{item.userDomain}</span>
                                    <CloseButton onClick={() => this.updateDeleteAdminValue(item.email)} />
                                </div>
                                
                            </Stack>
                        </ListGroupItem>
                    )}
                    {(!this.state.focusedDistrictAdmins || this.state.focusedDistrictAdmins.length === 0) &&
                        <ListGroupItem>No admins for district</ListGroupItem>
                    }
                </ListGroup>
                <InputGroup className="mt-2">
                    <Button className="ms-auto" onClick={() => this.openCreateAdminModal()}>Add admin user</Button>
                </InputGroup>
                {/* Modal */}
                <Modal show={!!this.state.adminDeleteModal} onHide={() => {this.updateDeleteAdminValue(undefined)}}>
                    <Modal.Header>
                        <Modal.Title>Are you sure you wish to remove this admin from its district?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>This admin will lose all access to Teach Insights.</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => {this.updateDeleteAdminValue(undefined)}}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={() => {this.removeAdminFromDistrict(this.state.adminDeleteModal)}}>
                            Delete
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={this.state.createUserModal} onHide={() => {this.closeCreateAdminModal()}}>
                    <Modal.Header>
                        Create Admin
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Control
                            value={this.state.createUserFirstName}
                            onChange={this.updateModalTypingValues('createUserFirstName')}
                            type="text"
                            placeholder="First name" 
                        />
                        <br />
                        <Form.Control
                            value={this.state.createUserLastName}
                            onChange={this.updateModalTypingValues('createUserLastName')}
                            type="text"
                            placeholder="Last name" 
                        />
                        <br />
                        <Form.Control
                            value={this.state.createUserEmail}
                            onChange={this.updateModalTypingValues('createUserEmail')}
                            type="text"
                            placeholder="Email"
                        />
                        <br />
                        <Dropdown>
                            <Dropdown.Toggle>{this.state.createUserDomain ?? 'Select domain for user'}</Dropdown.Toggle>
                            <Dropdown.Menu>
                                {this.state.schools && this.state.schools.map((school) => 
                                    <Dropdown.Item 
                                        onClick={() => this.updateModalSelector(school)}
                                    >{school}</Dropdown.Item>
                                )}
                                <Dropdown.Item onClick={() => this.updateModalTypingValues('createUserDomain', 'District')}>District</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => {this.closeCreateAdminModal()}}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={() => this.createNewUser()}>
                            Create
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Container>
        )
    }
}